module.exports = __webpack_public_path__ + "fonts/AmplitudeTF-Bold_1_4a53a8fa.5d16a1a1.ttf";